import type { HTMLAttributes } from 'react';
import clsx from 'clsx';

/**
 * Deutlich als eigenes blaues Panel erkennbar (klar hellerer Hintergrund als
 * die Seite, sichtbare Border, weicher Schatten für Tiefe) statt der zu
 * sterilen Vorversion (kein Schatten, kaum Kontrast zum Hintergrund) - aber
 * auch kein übertrieben großer Radius/Glasmorphismus-Look.
 */
export function Card({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('relative overflow-hidden rounded-lg border border-surface-600 bg-surface-800 shadow-card', className)} {...rest} />;
}

export function CardHeader({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('relative flex items-center justify-between gap-3 border-b border-surface-600 px-4 py-3.5', className)} {...rest} />;
}

export function CardTitle({ className, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={clsx('text-sm font-semibold text-ivory-100', className)} {...rest} />;
}

export function CardBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('relative p-4', className)} {...rest} />;
}
